import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { EEscapesEvents, IEscapesPillOnHome } from './types';

export const trackEscapesPillOnHome = (event: IEscapesPillOnHome) => {
  trackEventV2(EEscapesEvents.ESCAPES_PILL_ON_HOME, EProjectSection.MARKETPLACE, {
    ...event,
  });
};
